import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { AdvisorPickerRow } from "web_myplann/Advisor/Components/AdvisorPickerRow";
import type { AdvisorBaseDetail } from "web_myplann/Infrastructure/ApiOld/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

const R = Resources.Advisor;

type Props = {
	open: boolean;
	onClose: () => void;
	advisors: AdvisorBaseDetail[];
	selectedId: string;
	onSelect: (id: string) => void;
};

export const AdvisorPickerDrawer: FC<Props> = ({
	open,
	onClose,
	advisors,
	selectedId,
	onSelect,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			closeButton
			title={t(R.pickerTitle)}
			paperSx={{ bgcolor: theme.palette.background.paper }}
		>
			<Stack pb={2}>
				{advisors.map((advisor) => (
					<AdvisorPickerRow
						key={advisor.id}
						name={advisor.name ?? ""}
						photo={advisor.avatar ?? undefined}
						isMain={Boolean(advisor.is_main)}
						isSelected={advisor.id === selectedId}
						onClick={() => onSelect(advisor.id)}
					/>
				))}
			</Stack>
		</MyPlannDrawer>
	);
};
